module.exports = __webpack_public_path__ + "static/media/Download.c174d98b.svg";